<template>
  <section>
    <section class="desktop">
      <div @click="toggleAdmin" style="position: absolute; z-index: 50000; height: 51px; width: 51px;"></div>
      <transition name="slide">
        <div class="search-container open" v-show="searchOpen">
          <v-icon @click="toggleSearch"
                  class="closeSearch"
                  :size="30"
                  :color="'#FFFFFF'">
            close
          </v-icon>
          <input v-model="searchText" v-on:keyup.enter="onEnter" class="search" type="text" placeholder="What are you looking for?" >
        </div>
      </transition>
      <v-toolbar class="nav" light color="black">

        <v-spacer/>
        <v-toolbar-items>
          <section>
            <span class="nav-item"><a href="https://hydrafacial.com/careers/">CAREERS</a></span>
            <span class="nav-item-social">
              <a>
                <v-icon  @click="openFacebook"
                         class="social"
                         :size="20"
                         :color="'#FFFFFF'">
                  fab fa-facebook-f
                </v-icon>
              </a>
              <a>
                <v-icon @click="openInstagram"
                        class="social"
                        :size="20"
                        :color="'#FFFFFF'">
                  fab fa-instagram
                </v-icon>
              </a>
            </span>
            <span class="nav-item-search">
              <a>
                <v-icon 
                  @click="toggleSearch"
                  class="social"
                  :size="20"
                  :color="'#FFFFFF'">
                  fas fa-search
                </v-icon>
              </a>
            </span>
          </section>
          <span class="nav-item-provider" @click="openProvider">
            FIND A PROVIDER
          </span>
        </v-toolbar-items>

      </v-toolbar>
      <v-toolbar class="nav2" light color="white">
      
        <img class="logo" src="@/assets/logo.svg">
        <v-spacer/>

        <v-toolbar-items>
          <span class="nav-item2" @mouseover="treatmentHover = true" @mouseleave="treatmentHover = false" ><a  @click="openNewNav('https://hydrafacial.com/the-treatment/')">THE TREATMENT</a></span>
          <span class="nav-item2"><a href="https://assessment.hydrafacial.com/">FIND YOUR SKIN HEALTH</a></span>
          <span class="nav-item2" @mouseover="personalizationHover = true" @mouseleave="personalizationHover = false" ><a >PERSONALIZATION</a></span>
          <span class="nav-item2" @mouseover="communityHover = true" @mouseleave="communityHover = false" ><a @click="openNewNav('https://hydrafacialnation.com/meet-the-nation/')">COMMUNITY</a></span>
          <span class="nav-item2"><a  @click="openNewNav('https://hydrafacialco.com/')">FOR PROFESSIONALS</a></span>
        </v-toolbar-items>

      </v-toolbar>


      <transition name="fade">
        <div class="full-nav" 
             v-show="treatmentHover || personalizationHover || communityHover"
             @mouseleave="treatmentHover = false, personalizationHover = false, communityHover = false">
             
          <transition name="fade">
            <div @mouseover="treatmentHover = true" v-show="treatmentHover" >
              <div class="nav-treatment">
                <div class="nav-title" @click="openNewNav('https://hydrafacial.com/the-treatment/')">
                  <span class="hover bebas-0">THE HYDRAFACIAL TREATMENT</span>
                  <div class="nav-sub-title">
                    Only HydraFacial uses patented technology to cleanse, extract, and hydrate.
                  </div>
                  <div class="treatment-img-container">
                    <img class="treatment-img" @click="openNewNav('https://hydrafacial.com/the-treatment/')" src="@/assets/nav_01.jpg">
                  </div>
                </div>
              </div>
              <div class="nav-treatment">
                <div class="nav-title" @click="openNewNav('https://hydrafacial.com/the-treatment/#magic')">
                  <span class="hover bebas-0">HOW IT WORKS: SEE THE MAGIC</span>
                  <div class="nav-sub-title">
                    We want you to enjoy the experience, and delight in the results. See how it works!
                  </div>
                  <div class="treatment-img-container">
                    <img class="treatment-img" @click="openNewNav('https://hydrafacial.com/the-treatment/#magic')" src="@/assets/nav_02.jpg">
                  </div>
                </div>
              </div>
              <div class="nav-treatment">
                <div class="nav-title" @click="openNewNav('https://hydrafacial.com/skinhealth/')">
                  <span class="hover bebas-0">RETHINK YOUR SKIN HEALTH</span>
                  <div class="nav-sub-title">
                    Just like overall wellness, skin health isn't determined by just one or two factors.
                  </div>
                  <div class="treatment-img-container">
                    <img class="treatment-img" @click="openNewNav('https://hydrafacial.com/skinhealth/')" src="@/assets/nav_03.jpg">
                  </div>
                </div>
              </div>

            </div>
          </transition>





          <transition name="fade">
            <div @mouseover="personalizationHover = true" v-show="personalizationHover" >
              <div class="nav-person">
                <div class="person-title">SOLUTIONS FOR</div>
                <div @click="openNewNav('https://hydrafacial.com/solution/brighten/')" class="person-sub">Brightening</div>
                <div @click="openNewNav('https://hydrafacial.com/solution/calming/')" class="person-sub">Calming</div>
                <div @click="openNewNav('https://hydrafacial.com/solution/eye-perk/')" class="person-sub">Eye</div>
                <div @click="openNewNav('https://hydrafacial.com/solution/hydrate/')" class="person-sub">Hydration</div>
                <div @click="openNewNav('https://hydrafacial.com/solution/lip-perk/')" class="person-sub">Lip</div>
                <div @click="openNewNav('https://hydrafacial.com/solution/restore-firm/')" class="person-sub">Firming & Restoring</div>
                <div @click="openNewNav('https://hydrafacial.com/solution/smooth-refine/')" class="person-sub">Smoothing & Refining</div>
              </div>
              <div class="nav-person">
                <div class="person-title">BRANDS YOU'LL LOVE</div>
                <div @click="openNewNav('https://hydrafacial.com/brand/alastin/')" class="person-sub">Alastin</div>
                <div @click="openNewNav('https://hydrafacial.com/brand/circadia/')" class="person-sub">Circadia</div>
                <div @click="openNewNav('https://hydrafacial.com/brand/colorescience/')" class="person-sub">Colorescience</div>
                <div @click="openNewNav('https://hydrafacial.com/brand/hydrafacial/')" class="person-sub">HydraFacial</div>
                <div @click="openNewNav('https://hydrafacial.com/brand/hydropeptide/')" class="person-sub">HydroPeptide</div>
                <div @click="openNewNav('https://hydrafacial.com/brand/sente/')" class="person-sub">Senté</div>
                <div @click="openNewNav('https://hydrafacial.com/brand/zo-skin-health/')" class="person-sub">ZO Skin Health</div>
              </div>
              <div class="nav-person">
                <div class="person-title">CARE FOR</div>
                <div @click="openNewNav('https://hydrafacial.com/care/face/')" class="person-sub">Face</div>
                <div @click="openNewNav('https://hydrafacial.com/care/eye/')" class="person-sub">Eye</div>
                <div @click="openNewNav('https://hydrafacial.com/care/lip/')" class="person-sub">Lip</div>
                <div @click="openNewNav('https://hydrafacial.com/care/body/')" class="person-sub">Body</div>
              </div>
              <div class="nav-person">
                <div class="person-title">ENHANCEMENTS</div>
                <div @click="openNewNav('https://hydrafacial.com/enhancements/lymphatic/')" class="person-sub">Lymphatic</div>
                <div @click="openNewNav('https://hydrafacial.com/enhancements/led-lights/')" class="person-sub">LED lights</div>
                <div @click="openNewNav('https://hydrafacial.com/enhancements/tips/')" class="person-sub">Tips</div>
                <div @click="openNewNav('https://hydrafacial.com/enhancements/boosters/')" class="person-sub">Boosters</div>
              </div>
              <div class="nav-person">
                <div class="final-title">DON’T KNOW WHAT YOU WANT?</div>
                <div class="italic">Take your skin health assessment and see the solutions made for you.</div>
                <img class="begin-img" @click="openNewNav('https://assessment.hydrafacial.com/')"  src="@/assets/begin_now.png">
              </div>
            </div>
          </transition>




          <transition name="fade">
            <div @mouseover="communityHover = true" v-show="communityHover" >
              <div class="nav-community">
                <div class="community-title" @click="openNewNav('https://hydrafacialnation.com/')">WORLD TOUR</div>
                <img class="community-img" @click="openNewNav('https://hydrafacialnation.com/')"  src="@/assets/nav_nation.jpg">
              </div>
              <div class="nav-community">
                <div class="community-title" @click="openNewNav('https://hydrafacial.com/results/')">RESULTS</div>
                <img class="community-img" @click="openNewNav('https://hydrafacial.com/results/')" src="@/assets/nav_results.jpg">
              </div>
              <div class="nav-community">
                <div class="community-title" @click="openNewNav('https://hydrafacial.com/press/')">PRESS</div>
                <img class="community-img" @click="openNewNav('https://hydrafacial.com/press/')" src="@/assets/nav_press.jpg">
              </div>
              <div class="nav-community">
            
              </div>
              <div class="nav-community">
                <div class="community-title" @click="openNewNav('https://www.instagram.com/explore/tags/hydrafacialnation')">#HYDRAFACIALNATION</div>

                <div class="hf-nation-row">
                  <div class="hf-nation">
                    <img class="hfnation-img" @click="openNewNav('https://www.instagram.com/p/B2epb0bAJas/')" src="@/assets/insta-1.jpg">
                  </div>
                  <div class="hf-nation">
                    <img class="hfnation-img" @click="openNewNav('https://www.instagram.com/p/B2cIKKYHdVw/')" src="@/assets/insta-2.jpg">
                  </div>
                  <div class="hf-nation">
                    <img class="hfnation-img" @click="openNewNav('https://www.instagram.com/p/B2ZdFEtniCW/')" src="@/assets/insta-3.jpg">
                  </div>
                </div>
                <div class="hf-nation-row">
                  <div class="hf-nation">
                    <img class="hfnation-img" @click="openNewNav('https://www.instagram.com/p/B2W7EJyATEt/')" src="@/assets/insta-4.jpg">
                  </div>
                  <div class="hf-nation">
                    <img class="hfnation-img" @click="openNewNav('https://www.instagram.com/p/B2UWSQugJZK/')" src="@/assets/insta-5.jpg">
                  </div>
                  <div class="hf-nation">
                    <img class="hfnation-img" @click="openNewNav('https://www.instagram.com/p/B2RxgqbHQUG/')" src="@/assets/insta-6-1.jpg">
                  </div>
                </div>
              </div>
            </div>
          </transition>

        </div>
      </transition>
    </section>



    <section class="mobile">
      <img class="mobile-logo" src="@/assets/logo.svg">
      <v-icon @click="toggleMenu"
              class="mobile-menu"
              :size="40"
              :color="'black'">
        menu
      </v-icon>
    </section>
    
    <transition name="fade">
      <div class="menu" v-show="menuOpen">
        <div class="mobile-row-1">
          <div class="nav-item-provider-mobile" @click="openProvider">
            FIND A PROVIDER
          </div>

          <v-icon @click="toggleMenu"
                  class="mobile-menu"
                  :size="40"
                  :color="'white'">
            close
          </v-icon>

        </div>
        <div class="mobile-row-2 futura-0">


          <div @click="toggleTreatment" v-bind:class="{'opacity': treatmentExpanded }" class="mobile-nav-item">
            THE TREATMENT
            <v-icon
              v-if="!treatmentExpanded"
              class="carat"
              :size="30"
              :color="'white'">
              expand_more
            </v-icon>
            <v-icon
              v-if="treatmentExpanded"
              class="carat"
              :size="30"
              :color="'white'">
              expand_less
            </v-icon>
          </div>
        
          <!-- <transition name="mobile-slide"> -->
          <div class="sublinks" v-show="treatmentExpanded">
            <div class="heading bebas-0" @click="openNewNav('https://hydrafacial.com/the-treatment/')">
              THE HYDRAFACIAL TREATMENT
            </div>
            <div class="subheading">
              Only HydraFacial uses patented technology to cleanse, extract, and hydrate.
            </div>
            <div class="heading bebas-0" @click="openNewNav('https://hydrafacial.com/the-treatment/#magic')">
              HOW IT WORKS: SEE THE MAGIC
            </div>
            <div class="subheading">
              We want you to enjoy the experience, and delight in the results. See how it works!
            </div>
            <div class="heading bebas-0" @click="openNewNav('https://hydrafacial.com/skinhealth/')">
              RETHINK YOUR SKIN HEALTH
            </div>
            <div class="subheading">
              Just like overall wellness, skin health isn't determined by just one or two factors.
            </div>
          </div>
        
          <!-- </transition> -->

          <div class="mobile-nav-item" @click="findSkinHealth">FIND YOUR SKIN HEALTH</div>

          <div @click="togglePersonalization" v-bind:class="{'opacity': personalizationExpanded }" class="mobile-nav-item">
            PERSONALIZATION
            <v-icon
              v-if="!personalizationExpanded"
              class="carat"
              :size="30"
              :color="'white'">
              expand_more
            </v-icon>
            <v-icon
              v-if="personalizationExpanded"
              class="carat"
              :size="30"
              :color="'white'">
              expand_less
            </v-icon>
          </div>
          <div class="sublinks" v-if="personalizationExpanded">
            <div class="subsub">
              <div @click="toggleSolutions" v-bind:class="{'navborder': solutionsExpanded }">
                Solutions for
                <v-icon
                  v-if="!solutionsExpanded"
                  class="carat"
                  :size="30"
                  :color="'white'">
                  expand_more
                </v-icon>
                <v-icon
                  v-if="solutionsExpanded"
                  class="carat"
                  :size="30"
                  :color="'white'">
                  expand_less
                </v-icon>
              </div>
              <div v-if="solutionsExpanded">
                <div class="subsubsub" @click="openNewNav('https://hydrafacial.com/solution/brighten/')">Brightening</div>
                <div class="subsubsub" @click="openNewNav('https://hydrafacial.com/solution/calming/')">Calming</div>
                <div class="subsubsub" @click="openNewNav('https://hydrafacial.com/solution/eye-perk/')">Eye</div>
                <div class="subsubsub" @click="openNewNav('https://hydrafacial.com/solution/hydrate/')">Hydration</div>
                <div class="subsubsub" @click="openNewNav('https://hydrafacial.com/solution/lip-perk/')">Lip</div>
                <div class="subsubsub" @click="openNewNav('https://hydrafacial.com/solution/restore-firm/')">Firming & Restoring</div>
                <div class="subsubsub" @click="openNewNav('https://hydrafacial.com/solution/smooth-refine/')">Smoothing & Refining</div>
              </div>
            </div>

            <div class="subsub">
              <div @click="toggleBrands" v-bind:class="{'navborder': brandsExpanded }">
                Brands you'll love
                <v-icon
                  v-if="!brandsExpanded"
                  class="carat"
                  :size="30"
                  :color="'white'">
                  expand_more
                </v-icon>
                <v-icon
                  v-if="brandsExpanded"
                  class="carat"
                  :size="30"
                  :color="'white'">
                  expand_less
                </v-icon>
              </div>
              <div v-if="brandsExpanded">
                <div class="subsubsub" @click="openNewNav('https://hydrafacial.com/brand/alastin/')">Alastin</div>
                <div class="subsubsub" @click="openNewNav('https://hydrafacial.com/brand/circadia/')">Circadia</div>
                <div class="subsubsub" @click="openNewNav('https://hydrafacial.com/brand/colorescience/')">Colorescience</div>
                <div class="subsubsub" @click="openNewNav('https://hydrafacial.com/brand/hydrafacial/')">HydraFacial</div>
                <div class="subsubsub" @click="openNewNav('https://hydrafacial.com/brand/hydropeptide/')">HydroPeptide</div>
                <div class="subsubsub" @click="openNewNav('https://hydrafacial.com/brand/sente/')">Senté</div>
                <div class="subsubsub" @click="openNewNav('https://hydrafacial.com/brand/zo-skin-health/')">ZO Skin Health</div>
              </div>
            </div>

            <div class="subsub">
              <div @click="toggleCare" v-bind:class="{'navborder': careExpanded }">
                Care for
                <v-icon
                  v-if="!careExpanded"
                  class="carat"
                  :size="30"
                  :color="'white'">
                  expand_more
                </v-icon>
                <v-icon
                  v-if="careExpanded"
                  class="carat"
                  :size="30"
                  :color="'white'">
                  expand_less
                </v-icon>
              </div>
              <div v-if="careExpanded">
                <div class="subsubsub" @click="openNewNav('https://hydrafacial.com/care/face/')">Face</div>
                <div class="subsubsub" @click="openNewNav('https://hydrafacial.com/care/eye/')">Eye</div>
                <div class="subsubsub" @click="openNewNav('https://hydrafacial.com/care/lip/')">Lip</div>
                <div class="subsubsub" @click="openNewNav('https://hydrafacial.com/care/body/')">Body</div>
              </div>
            </div>

            <div class="subsub">
              <div @click="toggleEnhancements" v-bind:class="{'navborder': enhancementsExpanded }">
                Enhancements
                <v-icon
                  v-if="!enhancementsExpanded"
                  class="carat"
                  :size="30"
                  :color="'white'">
                  expand_more
                </v-icon>
                <v-icon
                  v-if="enhancementsExpanded"
                  class="carat"
                  :size="30"
                  :color="'white'">
                  expand_less
                </v-icon>
              </div>
              <div v-if="enhancementsExpanded">
                <div class="subsubsub" @click="openNewNav('https://hydrafacial.com/enhancements/lymphatic/')">Lymphatic</div>
                <div class="subsubsub" @click="openNewNav('https://hydrafacial.com/enhancements/led-lights/')">LED Lights</div>
                <div class="subsubsub" @click="openNewNav('https://hydrafacial.com/enhancements/tips/')">Tips</div>
                <div class="subsubsub" @click="openNewNav('https://hydrafacial.com/enhancements/boosters/')">Boosters</div>
              </div>
            </div>
          </div>

       
          <div @click="toggleCommunity" v-bind:class="{'opacity': communityExpanded }" class="mobile-nav-item">
            COMMUNITY
            <v-icon
              v-if="!communityExpanded"
              class="carat"
              :size="30"
              :color="'white'">
              expand_more
            </v-icon>
            <v-icon
              v-if="communityExpanded"
              class="carat"
              :size="30"
              :color="'white'">
              expand_less
            </v-icon>
          </div>
          <div v-if="communityExpanded">
            <div class="subsub" @click="openNewNav('https://hydrafacialnation.com/')">
              World Tour
            </div>
            <div class="subsub" @click="openNewNav('https://hydrafacial.com/results/')">
              Results
            </div>
            <div class="subsub" @click="openNewNav('https://hydrafacial.com/press/')">
              Press
            </div>
            <div class="subsub" @click="openNewNav('https://www.instagram.com/explore/tags/hydrafacialnation/')">
              #hydrafacialnation
            </div>
          </div>



          <div class="mobile-nav-item" @click="openProfessionals">FOR PROFESSIONALS</div>

        </div>
        <div class="mobile-row-3">
          <a>
            <v-icon  @click="openFacebook"
                     class="social"
                     :size="20"
                     :color="'#FFFFFF'">
              fab fa-facebook-f
            </v-icon>
          </a>
          <a>
            <v-icon @click="openInstagram"
                    class="social"
                    :size="20"
                    :color="'#FFFFFF'">
              fab fa-instagram
            </v-icon>
          </a>
        </div>

      </div>
    </transition>
  </section>
</template>

<script>
export default {
  name: 'navBar',
  props: {
    toggleAdmin: Function
  },
  computed: {
  },
  data() {
    return {
      searchText: '',
      treatmentHover: false,
      communityHover: false,
      personalizationHover:false,
      searchOpen: false,
      menuOpen: false,
      treatmentExpanded: false,
      personalizationExpanded: false,
      communityExpanded: false,
      solutionsExpanded: false,
      brandsExpanded: false,
      careExpanded: false,
      enhancementsExpanded: false
    };
  },
  methods: {
    openNav(link){
      window.open(link, '_self');
    },
    openNewNav(link){
      window.open(link, '_blank');
    },
    openProvider(){
      window.open('https://hydrafacial.com/find-a-provider/', '_self');
    },

    openFacebook(){
      window.open('https://www.facebook.com/hydrafacial/', '_blank');
    },
    openInstagram(){
      window.open('https://www.instagram.com/hydrafacial/', '_blank');
    },
    openProfessionals(){
      window.open('https://hydrafacialco.com/', '_self');
    },
    findSkinHealth(){
      window.open('https://assessment.hydrafacial.com/', '_blank');
    },
    toggleSearch(){
      this.searchOpen = !this.searchOpen;
    },
    toggleMenu(){
      this.menuOpen = !this.menuOpen;
    },
    toggleSolutions(){
      this.solutionsExpanded = !this.solutionsExpanded;
      this.brandsExpanded = false;
      this.careExpanded = false;
      this.enhancementsExpanded = false;
    },
    toggleBrands(){
      this.brandsExpanded = !this.brandsExpanded;
      this.careExpanded = false;
      this.solutionsExpanded = false;
      this.enhancementsExpanded = false;
    },
    toggleCare(){
      this.careExpanded = !this.careExpanded;
      this.brandsExpanded = false;
      this.solutionsExpanded = false;
      this.enhancementsExpanded = false;
    },
    toggleEnhancements(){
      this.enhancementsExpanded = !this.enhancementsExpanded;
      this.brandsExpanded = false;
      this.careExpanded = false;
      this.solutionsExpanded = false;
    },
    toggleTreatment(){
      this.treatmentExpanded = !this.treatmentExpanded;
      this.personalizationExpanded = false;
      this.communityExpanded = false;
    },
    togglePersonalization(){
      this.personalizationExpanded = !this.personalizationExpanded;
      this.treatmentExpanded = false;
      this.communityExpanded = false;
    },
    toggleCommunity(){
      this.communityExpanded = !this.communityExpanded;
      this.personalizationExpanded = false;
      this.treatmentExpanded = false;
    },
    onEnter(){
      window.open('https://hydrafacial.com/?s=' + this.searchText, '_self');
    }
  }
};
</script>

<style scoped>


.fade-enter-active, .fade-leave-active {
  transition: opacity .4s
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0
}

.slide-leave-active,
.slide-enter-active {
  transition: .3s;
}
.slide-enter {
  transform: translate(0, -100%);
}
.slide-leave-to {
  transform: translate(0, -100%);
}

.mobile-slide-leave-active,
.mobile-slide-enter-active {
  transition: .3s;
}
.mobile-slide-enter {
  transform: translate(0, -100%);
}
.mobile-slide-leave-to {
  transform: translate(0, -100%);
}


.begin-img{
  max-width: 100%;
  cursor: pointer;
}
.final-title{
font-weight: bold;
padding-bottom: 4px;

}
.italic{
  font-style: italic;
  padding-bottom: 4px;
}
.person-title{
  padding-bottom: 5px;
  font-weight: bold;
  text-decoration: underline;

}
.person-sub{
  
  padding-bottom: 2px;
}
.person-sub:hover{
  opacity: .5;
  cursor: pointer;

}
.hf-nation{
  float:left;
  width: 33%;
  text-align: center;

}

.hfnation-img{
  max-width: 95%;
  cursor:pointer;
}


.community-img{
  max-width: 100%;
  cursor: pointer;
}
.nav-title{
  text-align: left;
  padding-left: 5%;
  padding-right: 5%;
  padding-top: 20px;
  font-size: 18px;
  font-weight: bold;
}
.nav-sub-title{
  font-size: 15px;
  font-weight: normal;
  font-style: italic;
  margin-bottom: 20px;
  padding-bottom: 20px;
  border-bottom: 1px solid grey;
}
.treatment-img{
  max-width: 100%;
  padding-bottom: 10px;
  cursor:pointer;
}
.nav-treatment{
  float:left;
  width: 33%;
  text-align: center;
}
.nav-community{
  float:left;
  width: 20%;
  padding-top: 20px;
  padding-left: 3%;
  padding-right: 3%;

}
.nav-person{
  float:left;
  width: 20%;
  padding-top: 20px;
  padding-left: 3%;
  padding-right: 3%;
  padding-bottom: 20px;

}
.community-title{
  padding-bottom: 10px;
  font-weight: bold;
  text-decoration: underline;

}
.community-title:hover{
  cursor: pointer;
}
.full-nav{
  border-top: 1px solid grey;
  float: left;
    position: absolute;
    left: 0px;
    top: 135px;
    background-color: white;
    width: 100%;
    z-index: 99999999;
}
.hover:hover{
  text-decoration: underline;
  cursor: pointer;
}
.navborder{
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
}
.subsub{
  padding-left:20px;
  cursor: pointer;
  padding-top: 15px;
  font-size: 18px;
  padding-bottom: 10px;
  
}
.subsubsub{
  padding-left:20px;
  padding-top: 6px;
  
}
.subsubsub:hover{
  opacity: .5;
}

.opacity {
  opacity: .5 !important;
}

.sublinks{
  padding-bottom: 50px;
}

.heading{
  font-size: 15px;
  opacity: .5;
  padding-top: 40px;
  cursor:pointer;
}
.subheading{
  opacity: .5;
  font-size: 14px !important;
  font-style: italic;
}

.search-container{
  z-index: 50000;
  position: absolute;
  top: -200px;
  right: 205px;
}
.carat{
  position: absolute;
  right: 20px;
  margin-top: -2px;
}
.closeSearch{
  margin: 0px;
  padding: 0px;
  opacity: .5;
  position: absolute;
  top: 10px;
  right: 15px;
  z-index: 50000;
}
input.search:focus{
  outline-width: 0;
}
.mobile-row-1{
  padding-bottom: 10px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
}
.mobile-row-2{
  padding-top: 22px;
  padding-bottom: 22px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
}
.mobile-row-3{
  padding-top: 40px;
  text-align: center;
  padding-bottom: 40px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
}
.search{
  font-size: 17px;
  width: 280px;
  height: 51px;
  font-style: italic;
  background-color: black;
  color: white;
}
.open {
  top: 0px;
}
.mobile-menu{
  position: absolute;
  right: 10px;
  top: 3px;
}

.mobile-logo{
  max-width: 132px;
  padding-top: 10px;
  padding-left: 10px;
}

.mobile-nav-item{
  cursor: pointer;
  font-size: 20px;
  padding-top: 22px;
  padding-bottom: 22px;
}

.mobile-nav-item:hover{
  opacity: .5;
}

.nav-item-provider{
  background-color: #43aac5;
  color: white;
  margin-top: -20px;
  margin-right: -24px;
  padding-top: 20px;
  padding-left: 37px;
  padding-right: 37px;
  margin-left: -18px;
  font-size: 15px;
}
.nav-item-provider:hover{
  cursor: pointer;
  background-color: white;
  color: #43aac5;
}

.nav-item-provider-mobile{
  background-color: #43aac5;
  color: white;
  margin-top: 10px;
  font-size: 13px;
  width: 162px;
  height: 32px;
  padding-top: 7px;
  padding-left: 28px;
}
.nav-item-provider-mobile:hover{
  cursor: pointer;
  background-color: white;
  color: #43aac5;
}


.social{
  opacity: .5;
  padding-right: 20px;
  margin-top: -47px;
}

.social:hover{
  color: white;
  opacity: 1;
}

.nav {
  height: 51px;
  padding-top: 15px;

}

.nav2{
  height: 90px;

}

.nav-item{
  padding-bottom:20px;
  height: 200px;
  margin-top: -20px;
  padding-top: 19px;
  font-size: 15px;
  border-right: 1px solid rgba(255, 255, 255, 0.2);
  margin-right: 20px;
  padding-right: 20px;

  
}

.nav-item-social{
  height: 200px;
  padding-bottom:20px;
  margin-top: -20px;
  padding-top: 20px;
  font-size: 14px;
  border-right: 1px solid rgba(255, 255, 255, 0.2);
  margin-right: 20px;
  padding-right: 10px;
  padding-left: 10px;
  
}


.nav-item-search{
  height: 200px;
  margin-top: -20px;
  padding-top: 20px;
  font-size: 14px;
  margin-right: 20px;
  padding-right: 7px;
  padding-left: 7px;
  
}

.menu{
  z-index: 600000;
  position: absolute;
  top: 0px;
  bottom: 0px;
  left: 0px;
  right: 0px;
  background-color: black;
  padding-left: 30px;
  padding-right: 20px;
  color: white;
}

.open-menu{
  display: unset;
}

.mobile{
  max-height: 50px;
  display: none;
}

.nav-item a{
  color: white;
  opacity: .5;
  text-decoration: none;
}

.nav-item a:hover{
  opacity: 1;
  color: white;
  text-decoration: none;
}

.nav-item2{
  padding-top: 37px;
  padding-left: 65px;
  font-size: 14px;
  height: 90px;
}

.nav-item2 a{
  color: black;
  text-decoration: none;
}

.nav-item2 a:hover{
  opacity: 0.5;
}

.logo{
  padding-top: 35px;
  max-height: 79px;
}

@media (max-width: 1306px) {
  .nav2{
    max-height: 64px !important;
  }
.full-nav{
  top: 110px !important;
}
  .nav-item2{
    padding-top: 23px;
    padding-left: 20px;
    font-size: 12px;
  }
  .logo{
    margin-left: 20px !important;
    padding-top: 12px;
    max-width: 115px;
  }
}

@media (max-width: 794px) {
  .desktop{
    display: none;
  }
  .mobile{
    display: unset
  }
}

</style>